import { createContext, useContext, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';

const StripeContext = createContext(null);

export const StripeProvider = ({ children }) => {
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);
    const [stripeOpen, setStripeOpen] = useState(false);
    const [stripeClientSecret, setStripeClientSecret] = useState(null);

    return (
        <StripeContext.Provider
            value={{
                setStripeOpen,
                setStripeClientSecret,
                stripePromise,
                stripeOpen,
                stripeClientSecret,
            }}>
            {children}
        </StripeContext.Provider>
    );
};

StripeProvider.displayName = 'StripeProvider';

export const useStripe = () => useContext(StripeContext);
